import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

// Lazy HR pages
const HRDashboard        = lazy(()=>import('../modules/hr/pages/Dashboard'));
const HRApprovals        = lazy(()=>import('../modules/hr/pages/Approvals'));
const HRLeavesList       = lazy(()=>import('../modules/hr/pages/Leaves/LeavesList'));
const HRLeaveView        = lazy(()=>import('../modules/hr/pages/Leaves/LeaveView'));
const HRTravelsList      = lazy(()=>import('../modules/hr/pages/Travel/TravelsList'));
const HRTravelView       = lazy(()=>import('../modules/hr/pages/Travel/TravelView'));
const HRAdvancesList     = lazy(()=>import('../modules/hr/pages/Advance/AdvancesList'));
const HRAdvanceView      = lazy(()=>import('../modules/hr/pages/Advance/AdvanceView'));
const HRLoansList        = lazy(()=>import('../modules/hr/pages/Loan/LoansList'));
const HRLoanView         = lazy(()=>import('../modules/hr/pages/Loan/LoanView'));
const HRLeaveBalances    = lazy(()=>import('../modules/hr/pages/Leaves/LeaveBalances'));
const HRHolidayCalendars = lazy(()=>import('../modules/hr/pages/HolidayCalendars'));
const HRReports          = lazy(()=>import('../modules/hr/pages/Reports'));
const NewLeave          = lazy(()=>import('../modules/hr/pages/Leaves/NewLeave'));
const NewLoan          = lazy(()=>import('../modules/hr/pages/Loan/NewLoan'));
const Newtravel          = lazy(()=>import('../modules/hr/pages/Travel/NewTravel'));
 
const NewAdvance          = lazy(()=>import('../modules/hr/pages/Advance/NewAdvance'));

const Fallback = <div style={{ padding: 16 }}>Loading HR…</div>;

const withSuspense = (el: JSX.Element) => <Suspense fallback={Fallback}>{el}</Suspense>;

/**
 * Returns a Fragment (<>…</>) containing ONLY <Route> elements.
 * Use like: {renderHRRoutes(Protected)}
 */
export function renderHRRoutes(
  Protected: ({ children }: { children: JSX.Element }) => JSX.Element
): JSX.Element {
  return (
    <>
      <Route path="/hr" element={withSuspense(<Protected><HRDashboard /></Protected>)} />
      <Route path="/hr/approvals" element={withSuspense(<Protected><HRApprovals /></Protected>)} />

    <Route path="/hr/leaves/new" element={<Protected><NewLeave /></Protected>} />
      <Route path="/hr/leaves" element={withSuspense(<Protected><HRLeavesList /></Protected>)} />
      <Route path="/hr/leaves/:id" element={withSuspense(<Protected><HRLeaveView /></Protected>)} />

    <Route path="/hr/travels/new" element={<Protected><Newtravel /></Protected>} />
      <Route path="/hr/travels" element={withSuspense(<Protected><HRTravelsList /></Protected>)} />
      <Route path="/hr/travels/:id" element={withSuspense(<Protected><HRTravelView /></Protected>)} />

    <Route path="/hr/expense-advances/new" element={<Protected><NewAdvance  /></Protected>} />
      <Route path="/hr/expense-advances" element={withSuspense(<Protected><HRAdvancesList /></Protected>)} />
      <Route path="/hr/expense-advances/:id" element={withSuspense(<Protected><HRAdvanceView /></Protected>)} />

    <Route path="/hr/loans/new" element={<Protected><NewLoan /></Protected>} />
      <Route path="/hr/loans" element={withSuspense(<Protected><HRLoansList /></Protected>)} />
      <Route path="/hr/loans/:id" element={withSuspense(<Protected><HRLoanView /></Protected>)} />

      <Route path="/hr/admin/leave-balances" element={withSuspense(<Protected><HRLeaveBalances /></Protected>)} />
      <Route path="/hr/admin/holiday-calendars" element={withSuspense(<Protected><HRHolidayCalendars /></Protected>)} />

      <Route path="/hr/reports" element={withSuspense(<Protected><HRReports /></Protected>)} />


    
    </>
  );
}
